// Data awal yang disisipkan server ke HTML sebagai blok data JSON (<script type="application/json" id="…">), bukan script yang
// dijalankan — supaya CSP script-src tanpa 'unsafe-inline' (PR8). null bila tidak ada / rusak.
export function bacaDataAwal(id) {
  if (typeof document === "undefined") return null;
  try {
    const el = document.getElementById(id);
    return el ? JSON.parse(el.textContent) : null;
  } catch {
    return null;
  }
}
